module.exports = __webpack_public_path__ + "img/thumbnail_PronghornAntelope_m_albino.f3369845.png";